<template>
  <v-dialog
    fullscreen
    v-model="dialog"
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center mt-12">
            <div class="text-h5 mb-4">Impostazione {{ therm.nome }}</div>
          </v-col>
        </v-row>
        <v-subheader class="px-4">
          <span class="text-h6 font-weight-light">Setpoint</span>
        </v-subheader>
        <v-subheader class="px-4">
          <span
            :class="tempColor + '--text'"
            style="font-size: 20px; font-weight: 600"
            >{{ setpoint }} °C</span
          >
        </v-subheader>
        <v-row>
          <v-col cols="12" class="px-4">
            <v-slider
              v-model="setpoint"
              :min="0"
              :max="20"
              :step="0.5"
              thumb-label
              class="align-center"
              prepend-icon="mdi-minus"
              append-icon="mdi-plus"
              hide-details
              @click:prepend="setpoint = Math.max(0, setpoint - 0.5)"
              @click:append="setpoint = Math.min(20, setpoint + 0.5)"
            ></v-slider>
          </v-col>
        </v-row>
        <v-subheader>
          <span class="text-h6 font-weight-light">Allarme</span>
        </v-subheader>
        <v-subheader class="px-4">
          <span class="grey--text" style="font-size: 20px; font-weight: 600"
            >{{ alarmPoint }} °C</span
          >
        </v-subheader>
        <v-row>
          <v-col cols="12" class="px-4">
            <v-slider
              v-model="alarmPoint"
              :min="-5"
              :max="setpoint - 2"
              :step="0.5"
              thumb-label
              class="align-center"
              prepend-icon="mdi-minus"
              append-icon="mdi-plus"
              hide-details
              @click:prepend="alarmPoint = Math.max(-5, alarmPoint - 0.5)"
              @click:append="alarmPoint = Math.min(setpoint - 2, alarmPoint + 0.5)"
            ></v-slider>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mb-8">
        <v-spacer></v-spacer>
        <v-btn outlined color="green" @click="submitSetpoint">Salva</v-btn>
        <v-btn text @click="dialog = false">Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import set_point_mixin from "../mixin/therm_setpoint_box_mixin.js";
export default {
  props: {
    therm: {
      type: Object,
      required: true,
    },
  },
  mixins: [set_point_mixin],
  data() {
    return {};
  },
  computed: {
    tempColor() {
      const diff = 10 - this.setpoint;
      const mag = Math.abs(diff);
      const EPS = 1; // entro 1°C: circa uguale => verde

      // circa uguale
      if (mag <= EPS) return "green"; // green 600

      if (diff > 0) {
        // sotto setpoint => blu
        if (mag >= 6) return "indigo"; // blue 900
        if (mag >= 3) return "blue"; // blue 800
        if (mag >= 2) return "light-blue"; // blue 600
        return "cyan"; // blue 400
      }

      // sopra setpoint => arancio/rosso
      if (mag >= 6) return "deep-orange"; // red 800
      if (mag >= 3) return "orange"; // deep orange 600
      if (mag >= 2) return "amber"; // orange 600
      return "light-green"; // orange 600
    },
  },
  methods: {},
};
</script>
